export interface SocialMediaProfileLinksProps {
  socialMediaProfileLinks: SocialMediaProfileLinksMap;
  onInputChangeCallback: (socialMediaProfileName: SocialMediaProfile, url: string) => void;
  errorStates?: Record<SocialMediaProfile, boolean>;
  onInputBlurCallback?: (socialMediaProfileName: SocialMediaProfile) => void;
  containerClassName?: string;
  classMoreOptionsDropdown?: string;
}

export enum SocialMediaProfile {
  INSTAGRAM = 'instagram',
  FACEBOOK = 'facebook',
  X = 'x',
  YOUTUBE = 'youtube-channel',
  TIKTOK = 'tiktok-profile',
  PINTEREST = 'pinterest',
  LINKEDIN = 'linkedin',
}

export enum SocialMediaProfileDisplayName {
  INSTAGRAM = 'Instagram',
  FACEBOOK = 'Facebook',
  X = 'X (formerly Twitter)',
  YOUTUBE = 'YouTube',
  TIKTOK = 'TikTok',
  PINTEREST = 'Pinterest',
  LINKEDIN = 'LinkedIn',
}

export interface ValidFormattedSocialMediaLinks {
  isValid: boolean;
  formattedUrls: SocialMediaProfileLinksMap;
  errorMap: Record<SocialMediaProfile, boolean>;
}

export interface SocialMediaLinksValidationResult extends Omit<ValidFormattedSocialMediaLinks, 'formattedUrls'> {
  validatedUrls: SocialMediaProfileLinksMap;
}

export type SocialMediaProfileLinksMap = Record<SocialMediaProfile, string>;

export const PROFILE_LINK_HOST_PATTERNS: Record<SocialMediaProfile, readonly string[]> = {
  [SocialMediaProfile.INSTAGRAM]: ['instagram\\.com'],
  [SocialMediaProfile.FACEBOOK]: ['facebook\\.com'],
  [SocialMediaProfile.X]: ['x\\.com', 'twitter\\.com'],
  [SocialMediaProfile.YOUTUBE]: ['youtube\\.com'],
  [SocialMediaProfile.TIKTOK]: ['tiktok\\.com'],
  [SocialMediaProfile.PINTEREST]: ['pinterest\\.(?:com|[a-z]{2}|com\\.[a-z]{2}|co\\.[a-z]{2})'],
  [SocialMediaProfile.LINKEDIN]: ['linkedin\\.com'],
};

export const PROFILE_LINK_HANDLE_HOSTS: Record<SocialMediaProfile, string> = {
  [SocialMediaProfile.INSTAGRAM]: 'instagram.com',
  [SocialMediaProfile.FACEBOOK]: 'facebook.com',
  [SocialMediaProfile.X]: 'x.com',
  [SocialMediaProfile.YOUTUBE]: 'youtube.com',
  [SocialMediaProfile.TIKTOK]: 'tiktok.com',
  [SocialMediaProfile.PINTEREST]: 'pinterest.com',
  [SocialMediaProfile.LINKEDIN]: 'linkedin.com',
};

export const PROFILE_LINK_MAX_LENGTH = 2048;
export const PROFILE_LINK_HANDLE_PATTERN = /^[a-z0-9._]{1,30}$/i;
export const PROFILE_LINK_HANDLE_PREFIX = '@';
export const PROFILE_LINK_PATH_SEPARATOR = '/';
export const PROFILE_LINK_SCHEME_PATTERN = /^[a-z][a-z0-9+.-]*:/i;
export const PROFILE_LINK_SCHEME_LESS_DOMAIN_PATTERN = /\.com(\/|$)/i;
export const PROFILE_LINK_INVISIBLE_PADDING_PATTERN = /^[\p{Z}\p{Cc}\p{Cf}]+|[\p{Z}\p{Cc}\p{Cf}]+$/gu;
export const PROFILE_LINK_UNSAFE_CHARACTER_PATTERN = /[\s\p{Z}\p{Cc}\p{Cf}"'<>\\`]/u;
